module.exports = __webpack_public_path__ + "img/pjyl.118a4445.png";